import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TagService } from '../../task/tag/tag.service';
import { TagJoinService } from './../tag-join/tag-join.service';
import { AlertService } from '@app/_services';
import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ImportContactComponent} from '@app/_components/contact/import-contact/import-contact.component';
import {ImportDataComponent} from '@app/_components/_helpers/import-export/import-data/import-data.component';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as moment from 'moment';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Component({
    selector: 'app-import-export',
    templateUrl: './import-export.component.html',
    styleUrls: ['./import-export.component.css'],
    standalone: false
})
export class ImportExportComponent implements OnInit, OnChanges
{

	tagAddModalDialogRef: MatDialogRef<TagAddModalComponent>;

	@Output() messageEvent = new EventEmitter<string>();
    @Output() dataAndTagsSelected = new EventEmitter<any>();
    @Output() exportCSVSelected = new EventEmitter<any>();
    @Output() exportDataSelected = new EventEmitter<any>();
    @Input() dataRetrived: any[] ;
    @Input() fullList: any[] ;
    @Input() columns: any[] ;

	@Input() tagType: number;
	@Input() tagsourceForInput: number;
    @Input() importDisabled: false;
    @Input() exportLoading: boolean = false;
    private exportColumns: any[];
    @Input() sampleFileLink: any;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private tagService: TagService,
		private tagJoinService: TagJoinService,
		private alertService: AlertService,
		private dialog: MatDialog) { }

	ngOnInit()
	{
	}

  ngOnChanges(changes: SimpleChanges): void {
  }

  onImport() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    dialogConfig.data = {
      title: 'Import Data',
        tagsourceForInput: this.tagsourceForInput,
        sampleFileLink: this.sampleFileLink
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ImportDataComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.dataAndTagsSelected.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.dataAndTagsSelected.emit(data);
          dialogRef.close();
      });
  }

    exportSelected(exporttype: string) {
        this.exportDataSelected.emit(exporttype); //all data will not be fetched
        //this.exporData(exporttype, this.dataRetrived, 'exported_data');
    }
    public exporData(exporttype: string, json: any[], fileName: string): void {
        this.fullList = json;
        switch (exporttype){
            case 'excel':
                this.exportAsExcelFile(json, fileName);
                break;
            case 'pdf':
                this.exportPdf(json, fileName);
                break;
            case 'csv':
                this.exportAsCSVFile(this.fullList, fileName);
                break;
        }
    }
    public exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        // Convert date fields to real Excel date cells
        this.convertTextDatesToExcelDates(worksheet, ['holdDate', 'holdExpiredDate', 'cancelDate', 'saleDate', 'checkInDate', 'checkOutDate', 'trnsInEffectiveDate']);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }
    exportAsCSVFile(data: any[], fileName: string) {
        const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
        const header = Object.keys(data[0]);
        let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
        csv.unshift(header.join(','));
        let csvArray = csv.join('\r\n');

        let blob = new Blob([csvArray], {type: 'text/csv' });
        FileSaver.saveAs(blob, this.getFileName(fileName) + '.csv');
    }
    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, this.getFileName(fileName)+ EXCEL_EXTENSION);
    }

    getFileName(fileName: any){
        let time =  moment().format('MM-DD-YYYY_hh-mm-ss');
        if(fileName){
            return fileName += '_'+time;
        }else{
            return 'export_'+time;
        }
    }
    exportPdf(json: any[], excelFileName: string) {
        const doc = new jsPDF('p', 'pt', 'letter');
        this.exportColumns = this.columns.map(col => ({title: col.header, dataKey: col.field}));
        let head1= [];
        this.columns.forEach(col => (head1.push(col.field)));
        let fullData = [];
        for (let i= 0 ; i < json.length; i++){
            let entry=[];
            this.exportColumns.forEach(col => (entry.push(json[i][col.dataKey] )));
            fullData.push(entry);
        }
        let headMain =[];
        headMain.push(this.exportColumns);
        autoTable(doc, {
            head: headMain,
            body: fullData
        });
        doc.save(this.getFileName(excelFileName)+'.pdf');
    }
    onCSVExport() {
        this.exportCSVSelected.emit();
    }
    private convertTextDatesToExcelDates(ws: XLSX.WorkSheet, dateFields: string[]) {
        const range = XLSX.utils.decode_range(ws['!ref']);

        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = ws[cellAddress];

                if (!cell || cell.t !== 's') continue; // only process strings

                const headerCell = ws[XLSX.utils.encode_cell({ r: 0, c: C })];
                if (!headerCell) continue;

                const header = headerCell.v;

                if (dateFields.includes(header)) {
                    const value = cell.v;

                    if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {  
                        // Convert text to JS Date
                        const date = new Date(value);

                        // Convert to Excel date serial
                        const excelDate = (date.getTime() - new Date(Date.UTC(1899, 11, 30)).getTime()) / (24 * 3600 * 1000);

                        cell.v = excelDate;
                        cell.t = 'n';
                        cell.z = 'mm/dd/yyyy'; // Excel Short Date Format
                    }
                }
            }
        }
    }

}
